import {
  Edit,
  Datagrid,
  DateField,
  ImageField,
  List,
  Resource,
  Show,
  SimpleForm,
  SimpleShowLayout,
  TextField,
  TextInput,
  Create,
  NumberField,
  NumberInput
} from 'react-admin';
import { ColorField } from 'react-admin-color-picker';
import { ColorInput } from '../components/ColorInput';
import { FilterSidebar } from '../components/FilterSidebar';
import { ImageInput } from '../components/ImageInput';
import gql from 'graphql-tag';

export const name = 'Goal';
export const fragments = {
  type: 'document',
  doc: gql`
    fragment FragGoals on goals {
      id
      color
      description
      iconImageUrl
      name
      order
      createdAt
      updatedAt
      _count {
        exercises
        users
        userProfiles
        workouts
        __typename
      }
      __typename
    }
  `
};

const list = () => (
  <List aside={<FilterSidebar />} sort={{ field: 'name', order: 'ASC' }}>
    <Datagrid rowClick="show">
      <TextField source="id" />
      <TextField source="name" />
      <NumberField source="order" />
      <TextField source="description" />
      <ImageField source="iconImageUrl" />
      <ColorField soruce="color" />
      <DateField source="createdAt" />
      <DateField source="updatedAt" />
    </Datagrid>
  </List>
);

const show = () => (
  <Show>
    <SimpleShowLayout>
      <TextField source="id" />
      <TextField source="name" />
      <NumberField source="order" />
      <TextField source="description" />
      <ImageField source="iconImageUrl" />
      <ColorField soruce="color" />
      <DateField source="createdAt" />
      <DateField source="updatedAt" />
    </SimpleShowLayout>
  </Show>
);

const edit = () => (
  <Edit mutationMode="pessimistic">
    <SimpleForm>
      <TextField source="id" />
      <TextInput source="name" />
      <TextInput source="description" multiline rows={4} fullWidth />
      <NumberInput source="order" />
      <ImageInput source="iconImageUrl" />
      <ColorInput source="color" />
    </SimpleForm>
  </Edit>
);

const create = () => (
  <Create>
    <SimpleForm>
      <TextField source="id" />
      <TextInput source="name" />
      <TextInput source="description" multiline rows={4} fullWidth />
      <NumberInput source="order" />
      <ImageInput source="iconImageUrl" />
      <ColorInput source="color" />
    </SimpleForm>
  </Create>
);

export default function AdminResource(props) {
  return (
    <Resource
      create={create}
      edit={edit}
      list={list}
      name={name}
      show={show}
      {...props}
    />
  );
}
